import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["Component"];
import React from 'react';
import ReactDOM from 'react-dom';
import './Island.scss';
/**
 * This component bridges server-side and client-side rendering.
 *
 * Usage:
 *
 * // to be rendered by the server in the react tree
 * <div>
 *   <Island Component={MyComponentA} />
 *   <Island Component={MyComponentB} someProp="foo" />
 * </div>
 *
 * // then in postRenderHandler:
 * renderIslands({
 *   MyComponentA,
 *   MyComponentB,
 * });
 *
 * @param Component: The component to render on page load
 * @param ...props: Any props that Component would accept
 * @returns
 */
export var Island = function Island(_ref) {
  var Component = _ref.Component,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("div", {
    className: "island-mount-point",
    "data-component-name": Component.displayName || Component.name,
    "data-props": JSON.stringify(props)
  });
};
export var renderIslands = function renderIslands(components) {
  var allIslands = document.querySelectorAll('.island-mount-point');
  allIslands.forEach(function (island) {
    var componentName = island.getAttribute('data-component-name');
    var props = JSON.parse(island.getAttribute('data-props') || '{}');
    var Component = components[componentName];
    if (!Component) {
      throw new Error("Component not recognised: ".concat(componentName));
    }
    ReactDOM.render(/*#__PURE__*/React.createElement(Component, props), island);
  });
};